import * as React from 'react';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import '../../../../context/CmsContext.js';
import { PriceSection } from './PriceSection.js';

const PriceSectionContainer = ({ shouldDisplayFromPrice , fromPricePrefix ,  })=>{
    var ref, ref1;
    const { activeVariant , displayPrice  } = useProductData();
    return /*#__PURE__*/ React.createElement(PriceSection, {
        originalPrice: displayPrice.originalPrice,
        orignalPriceCurrencyCode: displayPrice.currency,
        discountedPrice: displayPrice.discountedPrice,
        discountBadge: (ref = displayPrice.discountInfo) === null || ref === void 0 ? void 0 : ref.discountBadge,
        discountDescription: (ref1 = displayPrice.discountInfo) === null || ref1 === void 0 ? void 0 : ref1.discountDescription,
        pricePerUnit: displayPrice.pricePerUnit,
        bestPrice: activeVariant.bestPrice,
        shouldDisplayFromPrice: shouldDisplayFromPrice,
        fromPricePrefix: fromPricePrefix
    });
};

export { PriceSectionContainer };
//# sourceMappingURL=PriceSectionContainer.js.map
